export enum RepositoryCleanerScheduleType {
    Daily = 0,
    Monthly = 1
}
